export default __webpack_public_path__ + "static/media/640_business03-it-web.e56b5756.png";